<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <template #default>
            <h3 class="text-center w-100">
              {{ $t('reply.posts-page-title',{page:currentPage.name}) }}
            </h3>
          </template>
        </b-card>
        <fetching-data-spinner
          :error="error"
          :loading="loading"
          :loading-title="$t('reply.loading-posts')"
          enable-retry
          @retry="fetchPosts"
        />
      </b-col>
      <template v-if="!loading && !error">
        <b-col
          v-for="post in posts"
          :key="post.id"
          xl="4"
          md="6"
          xxs="12"
        >
          <b-card
            no-body
            class="mb-2"
          >
            <div
              v-if="post.media_type==='VIDEO'"
              style="height: 200px;width: 100%"
            >
              <ok-video-player

                :src="post.picture"
                compact
              />
            </div>
            <div
              v-else
              v-lazy:background-image="post.picture"
              style="background-size: cover;height: 200px;background-position: center;width: 100%"
            />

            <b-card-body>
              <div class="d-flex justify-content-between">
                <span>
                  <FeatherIcon
                    size="20"
                    fill="#827F8D"
                    class="text-white ml-10"
                    icon="ClockIcon"
                  />
                  <i
                    class="text-muted"
                    style="margin-right: 3px; font-size: 12px"
                  >{{ post.created_at }}</i>

                </span>
              </div>
              <h5 class="mb-0 mt-1 text-center">
                {{ post.caption?post.caption:$t('general.no-text') }}
              </h5>
              <hr>
              <div class="d-flex justify-content-between align-items-center">
                <h5>{{ $t('instagram.comment-reply') }}</h5>
                <div v-if="post.enabled">
                  <b-button
                    v-b-tooltip.hover
                    variant="warning"
                    size="sm"
                    :title="$t('reply.edit')"
                    class="btn-icon"
                    @click="goEdit(post)"
                  >
                    <FeatherIcon icon="EditIcon" />
                  </b-button>
                  <b-button
                    v-b-tooltip.hover
                    variant="danger"
                    size="sm"
                    class="btn-icon ml-50"
                    :title="$t('reply.delete')"
                    @click="handleDelete(post)"
                  >
                    <FeatherIcon icon="TrashIcon" />
                  </b-button>
                </div>
                <b-button
                  v-else
                  v-b-tooltip.hover
                  :title="$t('reply.enable')"
                  variant="success"
                  size="sm"
                  class="btn-icon"
                  @click="goNew(post)"
                >
                  <FeatherIcon icon="PlusIcon" />
                </b-button>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </template>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BButton, VBTooltip, BCardBody,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import FetchingDataSpinner from '@/@bya3/components/utils/FetchingDataSpinner'
import InstagramReplyApi from '@/api/instagram/reply'
import InstagramMediaApi from '@/api/instagram/media'
import OkVideoPlayer from '@/@bya3/components/media/OkVidePlayer.vue'

export default {
  components: {
    OkVideoPlayer,
    FetchingDataSpinner,
    BRow,
    BCol,
    BCard,
    BButton,
    BCardBody,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      posts: [],
      error: null,
      loading: true,
      showInsightModal: false,
      showCommentModal: false,
      selectedPost: null,
    }
  },
  computed: {
    ...mapGetters({
      currentPageId: 'instagram/currentAccountId',
      currentPage: 'instagram/currentAccount',
    }),
  },
  watch: {
    currentPageId() {
      this.fetchPosts()
    },
  },

  mounted() {
    this.fetchPosts()
  },
  methods: {
    async fetchPosts() {
      this.loading = true
      try {
        // For direct Instagram accounts, page is null, so use account_id or 0 as pageId
        const pageId = this.currentPage.page?.id ?? null
        const res = await InstagramMediaApi.storiesList(pageId, this.currentPage.id)
        if (res.error === 0) this.posts = res?.stories ?? []
        else {
          this.error = res.message
        }
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
    handleDelete(post) {
      this.$okConfirm(this.$t('reply.delete-reply-message'), {
        preConfirm: () => InstagramReplyApi.deleteStoryReply(post.id)
          .then(response => {
            this.$notifySuccess(response.message)
            const index = this.posts.findIndex(p => p.id === post.id)
            if (index > -1) this.posts[index].enabled = false
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    goEdit(post) {
      this.$store.commit('reply/SET_FORM', { post_description: post?.caption ?? '', post_thumb: post.picture })
      this.$router.push({ name: 'owner:instagram-stories-reply-edit', params: { id: post.id } })
    },
    goNew(post) {
      this.$store.commit('reply/SET_FORM', { post_description: post?.caption ?? '', post_thumb: post.picture })
      this.$router.push({ name: 'owner:instagram-stories-reply', params: { id: post.id } })
    },
  },
}
</script>
